import Vue from 'vue'
import {
    Loading, 
    MessageBox,
    Pagination,
    Steps,
    Step,
    Scrollbar,
    Table,
    TableColumn,
    Timeline,
    TimelineItem
    // Button,
    // Radio,
    // Form,
    // FormItem,
    // Input,
    // DatePicker,
    // TimePicker,
    // Select,
    // Option,
    // Checkbox,
    // CheckboxGroup,
    // RadioGroup,
    // Menu,
    // Submenu,
    // MenuItem,
    // MenuItemGroup,
    
    // Col,
    // Row,
    // Table,
    // TableColumn,
    // RadioButton,
    
} from 'element-ui'

Vue.use(Loading.directive)
Vue.use(Pagination)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Scrollbar)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Timeline)
Vue.use(TimelineItem)
// Vue.use(Button)
// Vue.use(Radio)
// Vue.use(Form)
// Vue.use(FormItem)
// Vue.use(Input)
// Vue.use(DatePicker)
// Vue.use(Select)
// Vue.use(Option)
// Vue.use(Menu)
// Vue.use(Submenu)
// Vue.use(MenuItem)
// Vue.use(MenuItemGroup)
// Vue.use(Col)
// Vue.use(TimePicker)
// Vue.use(Row)
// Vue.use(Checkbox)
// Vue.use(CheckboxGroup)
// Vue.use(RadioGroup)
// Vue.use(Table)
// Vue.use(TableColumn)
// Vue.use(RadioButton)

Vue.prototype.$loading = Loading.service;
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$alert = MessageBox.alert;